export function hexToRgba(hex, alpha) {
  if (!hex || typeof hex !== "string" || !hex.startsWith("#")) {
    return `rgba(163,120,255,${alpha})`;
  }
  const h = hex.slice(1);
  const normalized = h.length === 3 ? h.split("").map((ch) => ch + ch).join("") : h;
  const int = parseInt(normalized, 16);
  if (Number.isNaN(int)) return `rgba(163,120,255,${alpha})`;
  const r = (int >> 16) & 255;
  const g = (int >> 8) & 255;
  const b = int & 255;
  return `rgba(${r},${g},${b},${Math.max(0, Math.min(1, alpha))})`;
}
